import { PermissionsKey } from '@vedalib/crud'
import { colorsTypes } from 'utils'

import { genField } from 'components/controls/Field'
import type { ISelectOption } from 'components/uiKit/Select'
import { t } from 'services/Translation'

export const name = (createdFor?: string, autoFocus?: boolean) =>
  genField({
    name: 'name',
    type: 'text',
    label: t('input.label.name'),
    params: {
      placeholder: t('input.placeholder.enterName'),
      autoFocus,
      disabled: createdFor === 'employee',
    },
    permission: {
      disabled: PermissionsKey.company_collections_company_u,
    },
    rules: [
      {
        required: true,
        message: t('input.error.required', { field: t('input.label.name') }),
      },
      {
        whitespace: true,
        message: t('input.error.whitespace'),
      },
      { max: 256 },
    ],
  })

export const color = genField({
  name: 'color',
  type: 'palette',
  label: t('input.label.borderColor'),
  params: { options: Object.values(colorsTypes) },
  permission: {
    disabled: PermissionsKey.company_collections_company_u,
  },
})

export const brand = (options: ISelectOption<string | null>[]) =>
  genField({
    type: 'select',
    name: 'brandId',
    label: t('input.label.branding'),
    layout: 'vertical',
    params: {
      options,
      dropdownType: 'dropdown',
      isSearch: true,
      placeholder: t('common.platformName'),
      fluid: true,
    },
    permission: {
      disabled: PermissionsKey.company_collections_company_u,
    },
  })

export const templateName = genField({
  name: 'name',
  type: 'text',
  label: t('input.label.name'),
  params: { placeholder: t('input.placeholder.enterName'), autoFocus: true },
  permission: {
    disabled: PermissionsKey.company_collections_company_u,
  },
  rules: [
    {
      whitespace: true,
      message: t('input.error.whitespace'),
    },
    { max: 256 },
    { required: true },
  ],
})

export const tagsField = (options: { value: string; label: string }[], defaultValue: string[]) =>
  genField({
    label: t('input.label.collectionTags'),
    name: 'templateTagIds',
    type: 'select',
    defaultValue,
    params: () => ({
      maxLength: 25,
      fluid: true,
      isMultiple: true,
      options,
      placeholder: t('input.placeholder.collectionTags'),
      inputable: true,
      resettable: true,
      autoFocus: true,
      isSearch: true,
      dropdownType: 'dropdown',
      hideEmptyList: true,
    }),
  })

export const InputErrorValues = {
  TEMPLATE_GROUP_NAME_NOT_UNIQUE: t('input.error.nameExist'),
}
